import { formatToUSPhoneNumber } from '../../services/textService';
import { message } from 'antd';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';

pdfMake.vfs = pdfFonts.vfs;

/**
 * Generates and downloads a PDF of the cover letter using pdfmake
 * @param {Object} userDetails - User details including name
 * @param {Object} resume - Resume object containing contact info
 * @param {string} coverLetterText - The cover letter text content
 * @param {string} jobTitle - Optional job title to include in filename
 */
const downloadCoverLetterAsPDF = (userDetails, resume, coverLetterText, jobTitle = '') => {
  try {
    const name = userDetails?.name?.trim() || 'Applicant';
    const phone = formatToUSPhoneNumber(resume?.phoneNumber || '');
    const email = resume?.email?.trim() || '';

    const docDefinition = {
      pageSize: 'LETTER',
      pageMargins: [72, 72, 72, 72], // 1-inch margins on all sides

      content: [
        // Name header
        {
          text: name,
          style: 'header'
        },
        // Contact info
        {
          columns: [
            { text: phone, width: 'auto', margin: [0, 0, 20, 0] },
            { text: email, width: '*' }
          ],
          margin: [0, 0, 0, 15]
        },
        // Divider
        {
          canvas: [
            {
              type: 'line',
              x1: 0,
              y1: 0,
              x2: 450,
              y2: 0,
              lineWidth: 1
            }
          ],
          margin: [0, 0, 0, 20]
        },
        // Main cover letter text
        {
          text: coverLetterText,
          style: 'body'
        }
      ],

      styles: {
        header: {
          fontSize: 20,
          bold: true,
          margin: [0, 0, 0, 10]
        },
        body: {
          fontSize: 11,
          lineHeight: 1.5,
          alignment: 'justify'
        }
      },

      defaultStyle: {
        font: 'Roboto'
      }
    };
    const cleanJobTitle = jobTitle ? `-${jobTitle.replace(/[^a-z0-9]/gi, '_')}` : '';
    const safeName = name.replace(/\s+/g, '_');
    const fileName = `CoverLetter-${safeName}${cleanJobTitle}.pdf`;

    pdfMake.createPdf(docDefinition).download(fileName);

    return true;
  } catch (error) {
    console.error('Error generating PDF:', error);
    message.error('Failed to generate PDF. Please try again.');
    return false;
  }
};

export default downloadCoverLetterAsPDF;